import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Renderer for Markdown links.
 * Opens links in a new tab and adds an icon to indicate this.
 */
export function MarkDownLinkRenderer(props: any) {
  return (
    <a href={props.href} target="_blank" rel="noreferrer">
      {props.children} <FontAwesomeIcon icon="arrow-up-right-from-square" />
    </a>
  );
}
